import React from 'react';
import { Player } from '../../types/game';
import { getAvatarUrl } from '../../utils/avatar';
import { useTheme } from '../../contexts/ThemeContext';
import { Card } from '../ui/Card';
import { Text } from '../ui/Text';

interface LobbyScreenProps {
  gamePin: string;
  players: Player[];
}

const LobbyScreen: React.FC<LobbyScreenProps> = ({ gamePin, players }) => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 animate-[fadeIn_0.3s_ease-in]">
      <Card
        variant="glass"
        elevation="xl"
        padding="lg"
        className="max-w-2xl w-full"
      >
        <div className="text-center mb-8">
          <div className="text-3xl mb-4">🎪</div>
          <Text as="h2" size="3xl" weight="bold" color="primary" align="center" className="mb-2">
            Get Ready to Crunch!
          </Text>
          <Text size="base" color="onSurfaceVariant" align="center">
            Waiting for the quiz master to start the show...
          </Text>
        </div>

        <div className="flex justify-center mb-8">
          <div
            className="rounded-2xl p-6 text-center transform hover:scale-105 transition-transform duration-300"
            style={{
              background: theme.colors.secondary,
              color: theme.colors.onSecondary,
            }}
          >
            <div className="text-3xl mb-2">👥</div>
            <Text size="sm" weight="semibold" className="opacity-90" style={{ color: theme.colors.onSecondary }}>
              Players Ready
            </Text>
            <Text as="div" size="2xl" weight="bold" style={{ color: theme.colors.onSecondary }}>
              {players.length}
            </Text>
          </div>
        </div>

        <div className="mb-6">
          <Text as="h3" size="xl" weight="bold" color="primary" align="center" className="mb-4">
            🌟 Quiz Warriors 🌟
          </Text>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-48 overflow-y-auto">
            {players.map((player) => (
              <div
                key={player.id}
                className="flex items-center gap-3 px-4 py-2 rounded-xl font-bold transform hover:scale-105 transition-transform duration-200 min-h-[48px]"
                style={{
                  background: theme.colors.primary,
                  color: theme.colors.onPrimary,
                }}
              >
                <img
                  src={getAvatarUrl(player.name, 64)}
                  className="w-10 h-10 rounded-full"
                  style={{
                    border: `2px solid ${theme.colors.outline}`,
                  }}
                  alt={`${player.name}'s avatar`}
                />
                <span className="flex-1 text-center">{player.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="animate-pulse text-2xl mb-2">⏳</div>
          <Text size="base" weight="semibold" color="onSurfaceVariant" align="center">
            The adventure begins soon...
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default LobbyScreen;